import { getSpacing } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import styled, { css } from "styled-components";

export const LoggedOutCategoryPageWrapper = styled.div<{
  $isLoggedOutCategoryPageRedesign?: boolean;
  $noPaddingOnMobile?: boolean;
}>`
  display: flex;
  flex-direction: column;
  width: 100%;

  ${({ $isLoggedOutCategoryPageRedesign, $noPaddingOnMobile }) =>
    $isLoggedOutCategoryPageRedesign
      ? css`
          ${responsiveMediaQueries.desktopAndAbove} {
            max-width: 1920px;
            margin: auto;
            padding: ${getSpacing(0, "6x")};
          }
          ${responsiveMediaQueries.tabletAndBelow} {
            padding: ${getSpacing(0, "2x")};
          }
          ${$noPaddingOnMobile
            ? css`
                ${responsiveMediaQueries.mobile} {
                  padding: 0;
                }
              `
            : ""}
        `
      : css`
          max-width: 1280px;
          margin: 0 auto;
          padding: ${getSpacing(0, "2x")};
          ${responsiveMediaQueries.tabletAndAbove} {
            padding: ${getSpacing(0, "5x")};
          }
          ${responsiveMediaQueries.desktopAndAbove} {
            padding: ${getSpacing(0, "10x")};
          }
          ${$noPaddingOnMobile
            ? css`
                ${responsiveMediaQueries.mobile} {
                  padding: 0;
                }
              `
            : ""}
        `}
`;
